import React from "react";

const ProcessResultCard = ({
  img,
  title,
  text
}) => {
  return(
    <div className="process-result-card">
      <div className="process-result-card-img">
        {img}
      </div>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}

export default ProcessResultCard;